import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
  canonicalUrl?: string;
  schemaData?: any;
}

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  ogImage, 
  canonicalUrl,
  schemaData 
}: SEOHeadProps) => {
  const location = useLocation();
  const baseUrl = "https://w-wagner.art";
  
  const finalCanonical = canonicalUrl || `${baseUrl}${location.pathname}`;
  const finalOgImage = ogImage || `${baseUrl}/hero-gallery.jpg`;
  
  return (
    <>
      <Helmet>
        {/* Title */}
        {title && <title>{title}</title>}
        
        {/* Meta Description - КРИТИЧНО для SEO */}
        {description && <meta name="description" content={description} />}
        
        {/* Meta Keywords */}
        {keywords && keywords.length > 0 && (
          <meta name="keywords" content={keywords.join(', ')} />
        )}
        
        {/* Canonical URL - КРИТИЧНО для избежания дублей */}
        <link rel="canonical" href={finalCanonical} />
        
        {/* Open Graph теги для соцсетей */}
        {title && <meta property="og:title" content={title} />}
        {description && <meta property="og:description" content={description} />}
        <meta property="og:url" content={finalCanonical} />
        <meta property="og:image" content={finalOgImage} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="W-Wagner.art" />
        
        {/* Twitter Card */}
        {title && <meta name="twitter:title" content={title} />}
        {description && <meta name="twitter:description" content={description} />}
        <meta name="twitter:image" content={finalOgImage} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      
      {/* Schema.org JSON-LD структурированные данные */}
      {schemaData && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(schemaData, null, 2)}
          </script>
        </Helmet>
      )}
    </>
  );
};

export default SEOHead;